<!-- 成长表现 -->
<template>
    <div class="wrap">
        <div class="top">
            <h5>成长表现</h5>
            <div class="right">
                <vxe-select v-model="val1" placeholder="请选择" class="custom-select" @change="tab1Change">
                    <vxe-option v-for="{label,value} in selectOption" :key="label" :value="value" :label="label"></vxe-option>
                </vxe-select>
                <el-radio-group class="custom-tab" v-model="tab1Position" @change="tab1Change">
                    <el-radio-button label="总量">总量</el-radio-button>
                    <el-radio-button label="增量">增量</el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <p class="text1">
         {{ val1 }}涨粉 <span class="high-light">{{ fanIncrease }}</span>
         {{ val1 }}涨粉率 <span class="high-light">{{ fanIncreaseRate }}%</span>
        </p>
        <div class="chartContainer" v-loading="loading">
            <LineChart :lineChartInfo="fansNumChart" ref="fansNumChartRef" />
        </div>
    </div>
</template>
<script>
import { apiCache } from '@/utils/index.js';
import LineChart from "../../../components/Echart/LineChart.vue"
export default {
    components: {
        LineChart
    },
    props:["fatherDarenInfo"],
    data() {
        return {
            flag:true,
            val1:"近7天",
            tab1Position: "总量",
            fansNumChart:{//粉丝趋势折线图信息
                nodeId:'fansNum',//节点
                data: [0],//数据
                smooth:true,//平滑
                xAxisData:['-'],//x轴的数据
                yAxisName:'粉丝人数',
                tooltipName:'粉丝总量',
                unit:''
            },
            selectOption:[
                { label:'近7天', value:'近7天'},
                { label:'近30天', value:'近30天'},
                { label:'近90天', value:'近90天'},
                { label:'近180天', value:'近180天'},
                { label:'近1年', value:'近1年'},
            ],
            fanIncrease:'-', //涨粉
            fanIncreaseRate:'-', // 涨粉率
            loading:false
        }
    },
    methods: {
        tab1Change() {
            if (this.tab1Position === "总量") {
                // this.initBlAttention(JSON.parse(window.sessionStorage.getItem('getBlAttention')).data.data)
                this.fetchBlAttentionData('getBlAttention',1)
            } else if (this.tab1Position === "增量") {
                // this.initBlAttention(JSON.parse(window.sessionStorage.getItem('getBlAttention2')).data.data)
                this.fetchBlAttentionData('getBlAttention',2)
            }
        },
        initBlAttention(val) {
            let fanIncrease,fanIncreaseRate,len
            switch (this.val1) {
                case '近7天':
                    len = 7
                    fanIncrease = val.fans_inc7
                    fanIncreaseRate = val.fans_inc_rate7
                    break;
                case '近30天':
                    len = 30
                    fanIncrease = val.fans_inc30
                    fanIncreaseRate = val.fans_inc_rate30
                    break;
                case '近90天':
                    len = 90
                    fanIncrease = val.fans_inc90
                    fanIncreaseRate = val.fans_inc_rate90
                    break;
                case '近180天':
                    len = 180
                    fanIncrease = val.fans_inc180
                    fanIncreaseRate = val.fans_inc_rate180
                    break;
                case '近1年':
                    len = 365
                    fanIncrease = val.fans_inc365
                    fanIncreaseRate = val.fans_inc_rate365
                    break;
            }
            this.fanIncrease = fanIncrease
            this.fanIncreaseRate = fanIncreaseRate

            let fansNumChart = {
                nodeId: 'fansNum',//节点
                data: [],//数据
                smooth: true,//平滑
                xAxisData: [],//x轴的数据
                yAxisName: '粉丝人数',
                tooltipName: '粉丝总量',
                unit: ''
            }
            // 接口会将1年的数据都返回，这里从后向前取日期对应的数据
            val?.data_statistics_by_day_vos?.slice(-1*len)?.forEach?.(item => {
                fansNumChart.xAxisData.push(item.date)
                fansNumChart.data.push(item.count)
            })
            this.fansNumChart = fansNumChart

            if (!this.flag) {
                this.$refs.fansNumChartRef.lineChart(this.fansNumChart)
            }
        },
        async fetchBlAttentionData(key,type){
            try {
                this.loading = true
                const res = await apiCache(key+type,()=>this.$api.getBZhanData.getBlAttention(`?upper_mid=${this.$route.query.up_id}&query_type=${type}`))
                this.loading = false
                if(res.data.code!==0){return}
                this.initBlAttention(res.data.data)
            } catch (error) {
                console.log('error :>> ', error);
            }
        }
    },
    mounted() {
        if(this.flag){
            this.$refs.fansNumChartRef.lineChart(this.fansNumChart)
            this.flag = false
        }
    },
    created(){
        this.fetchBlAttentionData('getBlAttention',1)
    }
};
</script>
<style lang='scss' scoped>

.custom-select{
    margin-right: 14px;
}
/* 粉丝趋势折线图 */
#fansNum{
    width: 100%;
    height: 288px;
}

</style>